import { useState, useContext } from "react";
import PointsHistory from "../components/PointsHistory";
import api from "../api";
import { UserContext } from "../context/UserContext";

export default function AdminPointsHistory() {
  const { user } = useContext(UserContext);
  const [selectedUser, setSelectedUser] = useState(null);
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [source, setSource] = useState("admin");
  const [assignError, setAssignError] = useState("");
  const [assignSuccess, setAssignSuccess] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.get(`/users/list?q=${encodeURIComponent(search)}`);
      setResults(res.data.items || []);
    } catch {
      setResults([]);
    }
    setLoading(false);
  };

  return (
    <div style={{width:'100vw',margin:0,padding:0,display:'flex',justifyContent:'center'}}>
      <div className="home-page" style={{padding:32,maxWidth:760,width:'100%', position:'relative', left:'-120px'}}>
        <h1 style={{marginBottom:24}}>Punktehistorie eines Nutzers</h1>
        <form onSubmit={handleSearch} style={{marginBottom:16,display:'flex',gap:8}}>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Benutzername oder Displayname suchen"
            style={{flex:1,padding:8,fontSize:16}}
          />
          <button type="submit" disabled={loading} style={{padding:'8px 16px',fontSize:16}}>
            Suchen
          </button>
        </form>
        {results.length > 0 && (
          <ul style={{listStyle:'none',padding:0,marginBottom:24}}>
            {results.map(u => (
              <li key={u.id} style={{marginBottom:8}}>
                <button
                  onClick={() => setSelectedUser(u)}
                  style={{padding:'6px 12px',fontSize:15,borderRadius:6,border:'1px solid #ccc',background:'#222',color:'#32CD89',cursor:'pointer'}}
                >
                  {u.displayName || u.username} (ID: {u.id})
                </button>
              </li>
            ))}
          </ul>
        )}
        {selectedUser && (
          <div style={{marginTop:24}}>
            <h2>Punktehistorie von {selectedUser.displayName || selectedUser.username}</h2>
            {(Array.isArray(user?.roles) && (user.roles.includes('admin') || user.roles.includes('moderator'))) && (
            <form
              onSubmit={async e => {
                e.preventDefault();
                setAssignError("");
                setAssignSuccess("");
                setAssignLoading(true);
                try {
                  await api.post(`/admin/user/${selectedUser.id}/points`, {
                    amount: parseFloat(amount),
                    reason,
                    source
                  });
                  setAssignSuccess("Punkte erfolgreich vergeben.");
                  setAmount("");
                  setReason("");
                  setSource("admin");
                } catch (err) {
                  setAssignError(err?.response?.data?.error || "Fehler beim Vergeben der Punkte.");
                }
                setAssignLoading(false);
              }}
              style={{marginBottom:24,display:'flex',flexDirection:'column',gap:8,padding:16,border:'1px solid #444',borderRadius:8,background:'#181818'}}
            >
              <div style={{fontWeight:'bold',marginBottom:4}}>Punkte vergeben</div>
              <input
                type="number"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                placeholder="Anzahl Punkte (z.B. -10 für Abzug)"
                style={{padding:8,fontSize:16}}
                required
              />
              <input
                type="text"
                value={reason}
                onChange={e => setReason(e.target.value)}
                placeholder="Grund (z.B. Aktivität, Event, Admin-Vergabe)"
                style={{padding:8,fontSize:16}}
                required
              />
              <input
                type="text"
                value={source}
                onChange={e => setSource(e.target.value)}
                placeholder="Quelle (z.B. admin, system, event)"
                style={{padding:8,fontSize:16}}
                required
              />
              <button type="submit" disabled={assignLoading} style={{padding:'8px 16px',fontSize:16,background:'#32CD89',color:'#222',borderRadius:6,border:'none',marginTop:8}}>
                Punkte vergeben
              </button>
              {assignError && <div style={{color:'red',marginTop:4}}>{assignError}</div>}
              {assignSuccess && <div style={{color:'green',marginTop:4}}>{assignSuccess}</div>}
            </form>
            )}
            <PointsHistory userId={selectedUser.id} />
          </div>
        )}
      </div>
    </div>
  );
}
